import { useCallback, useMemo } from "react";
import { useSelectionContext } from "./selection-context";

export interface SelectionEntry<T = unknown> {
	id: string;
	payload: T;
}

export function useSelection<T = unknown>() {
	const { selectedIds, setSelectedIds, payloads, cancelCurrentSelection } = useSelectionContext();

	const selected = useMemo(
		() =>
			Array.from(selectedIds).map((id) => ({
				id,
				payload: payloads.get(id) as T,
			})),
		[selectedIds],
	);

	const clearSelection = useCallback(() => setSelectedIds(new Set()), [setSelectedIds]);

	return {
		selected,
		selectedIds,
		hasSelection: selectedIds.size > 0,
		clearSelection,
		cancelCurrentSelection,
	};
}
